export const labels = {
  //Validation
  missingReferenceSheet:
    "ワークシート「Reference_sheet」が見つかりませんでした。新規ワークブックでEY Canvas Bulk Updateアドインを開き再試行してください。",
  descriptionError: "説明が最大文字数 ({0}文字)を超えています",
  titleMissingError: "タイトルがありません（必須）",
  titlemaxLimitError: "タイトルが最大文字数 ({0}文字)を超えています",
  userNotFromSelectedGroup:
    "リクエストはグループ及びユーザーの両方に割当てることはできません",
  dueDateFormatError: "期日の無効な日付形式",
  fieldError:
    "一部のレコードにエラーがあるため、EY Canvas を更新できませんでした。詳細はステータス列を確認してください。",
  invalidColumn: "{0}の無効なデータ",
  requiredColumn: "{0}が必要です。",
  hashValueMissing:
    "EY Canvasを更新するにはハッシュ値が必要です。このワークシートの該当の列を確認してください。",
  // Panel Headers
  engagement: "エンゲージメント",
  select: "選択",
  numberOfRecords: "レコード数",
  dowanloadedOn: "ダウンロード日",
  canvasUpdatesOn: "処理のためにEY Canvasに送信する",
  selectRecordsToUpdate: "更新するレコードの選択",
  atlasWorkpaperIndexFramework: "EY Atlas: 監査調書インデックスフレームワーク",
  referenceOnly: "参照専用",
  columnsToUpdate: "これらの列を更新",
  dueDateRequired: "期日は必須です",
  requestNotAssignedError: "リクエストをグループ又はユーザーに割当てる",
  infoText:
    "同じワークブック内の複数のシートで、EY Canvas Bulk Updateアドインを実行することはできません。新しい項目またはEY Canvasエンゲージメントを編集するには、このツールを新規ワークブックで開いてください。",
  noUpdatesSaved: "保存された更新はありません",
  dummyLocalizationText: "ダミーローカライゼーションテキスト",
  unexpectedApiFailure:
    "予期しない API エラーが発生しました。再試行してください。",
  titleLengthExceeded: "タイトルが最大文字数 (500文字)を超えています",
  DescriptionLengthExceeded: "説明が最大文字数 (4000文字)を超えています",
  canvasDataEditor: "Canvasデータエディタ",
  selectanitemtoedit: "オプションを選択",
  editRequestMessage: "どのリクエストを編集しますか?",
  selectRequestStatus: "リクエストのステータスを少なくとも1つ選択してください",
  selectRequestErrorMessage:
    "リクエストのステータスを少なくとも1つ選択してください",
  sheetWithSameNameExist:
    "Input_sheet_{0}という名前のシートは既に存在します。続行するには、シートの名前を変更してください。",
  engagementIdNotFound:
    "EY Canvas のエンゲージメントが見つかりませんでした。エンゲージメント ID を確認し、EY Canvas エンゲージメントを開くためのアクセス権があることを確認してください。",
  boundSheetAlreadyExist_1: "EY Canvas Bulk Updateアドイン",
  boundSheetAlreadyExist_2: "このタブでは使用できません",
  selectAnOperation: "何をしますか？",
  submit: "提出",
  next: "次",
  eyCanvasEngagement: "エンゲージメントの選択",
  search: "検索する",
  engagementNotSelected: "エンゲージメントの選択",
  invalidEngagement: "有効なエンゲージメントを選択",
  back: "戻る",
  noRecordsFound: "レコードがありません",
  masterSheetNoteText:
    "注: このシートではEY Canvas Bulk Updateアドインの使用が必須です。",
  informationText: "このツールでは、次のことができます:",
  infoText1:
    "標準化されたインデックス作成のために、EY Canvas文書及びタスク名を編集し、",
  infoText3: "EY Canvasの他のアイテムを作成・編集",
  infoTextforonlyAddClientRequest: "クライアントリクエストの作成",
  yes: "はい",
  no: "いいえ",
  close: "閉じる",
  ownedByEngagement: "このエンゲージメントから共有",
  sharedToEngagement: "このエンゲージメントに共有",
  status: "ステータス",
  statusId: "ステータスID",
  Continue: "続行",
  updateCanvas: "EY Canvasにアップロード",
  newDocumentName: "新規文書名",
  documentName: "文書名",
  fileExt: "ファイル拡張子",
  shared: "共有済",
  docId: "文書ID",
  hash: "ハッシュ",
  newPrefix: "新規プレフィックス",
  newSuffix: "新規サフィックス",
  newTitle: "新規タイトル",
  taskPrefix: "タスクのプレフィックス",
  taskSuffix: "タスクのサフィックス",
  taskTitle: "タイトル",
  taskType: "タスクタイプ",
  taskTitleEditable: "編集可能なタスクタイトル",
  auditPhase: "監査フェーズ",
  milestone: "マイルストーン",
  timePhase: "タイムフェーズ",
  taskId: "タスクID",
  populateMsg: "EY Canvasから記録を入力する",
  updatingCanvas:
    "EY Canvasを更新しています。 <br />この作業には数分かかります。",
  loadingContent: "コンテンツのロード中",
  filenameRequired: "ファイル名は必須です",
  excelError: "Excelの数式エラーです。修正して再試行してください。",
  specialCharacters:
    "文書名に次の文字を含めることはできません */:<>\\?|" + '"',
  sameDocumentNameError: "文書名が重複しています",
  docNameLimit: "文書名は115文字を超えることはできません",
  markValueInvalid: "「EY Canvas」の値が無効です。修正して再試行してください。",
  docAndHashNull:
    "EY Canvas を更新するには文書 ID および/またはハッシュ値が必須です。このワークシートのこれらの列を確認してください。",
  help: "ヘルプ",
  entityNotSelected: "続行するにはオプションを選択してください",
  AssignedToGroupInputMessageTitle: "グループを選択（任意）",
  AssignedToGroupInputMessageDescription:
    "グループ全体に割当てるには、グループを選択し、次の列を空にしてください。",
  AssignedToUserInputMessageTitle: "ユーザーを選択（任意）",
  AssignedToUserInputMessageDescription:
    "特定のユーザーに割当てるには、ユーザーを選択し、前の列を空にしてください。ユーザーはグループごとにリストされます。\n\n 注意：すべてのグループメンバーがリクエストを閲覧できます。ユーザーが複数のグループに属している場合は、正しいドロップダウンオプションを選択しているか確認してください。",
  apiServerExceptionError:
    "EY Canvas への接続中にエラーが発生しました。再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
  taskNameExceedsLimit:
    "文字数制限を超えています（タイトル：500文字、プレフィックス/サフィックス：50文字）",
  taskTypeUpdateNotAllowed: "このタスクタイプのタスクタイトルは編集できません",
  taskEmptyHashOrDocId:
    "EY Canvasを更新するためにタスクIDおよび/またはハッシュ値が必須です。このワークシートのこれらの列を確認してください。",
  taskTitleRequiredError: "タスクタイトルは必須です",
  sameTaskNameError:
    "新しいタスク名と古いタスク名(プレフィックス、サフィックス、タイトル)が同じです",
  universalUserPreferenceGetError:
    "EY Canvas への接続中にユーザー設定エラーが発生しました。再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
  sameWorkbookMultipleSessionsError:
    "同じワークブック内で複数の編集セッションを実行することはできません。新しい項目または EY Canvas エンゲージメントを編集するには、このツールを新規ワークブックで開いてください。",
  errorMessageOnExcelUpdate:
    "一部のレコードにエラーがあるため、EY Canvasを更新できませんでした。詳細は、<b>ステータス</b>列を確認してください。",
  insufficientPermissionsError:
    "権限が不足しています。EY Canvasエンゲージメントが開けることを確認し、再試行してください。",
  ApiValidationErrorPreConditionFailedDocument:
    "EY Canvasを更新できませんでした。文書の一部が移動または削除された可能性があります。新規ワークブックにデータを再度ロードして、再試行してください。",
  ApiValidationFailedWithErrorDocument:
    "一部の文書にエラーがあるため、EY Canvas を更新できませんでした。詳細はステータス列を確認してください。",
  apiServerConnectError:
    "EY Canvasに接続できませんでした。このエンゲージメントを編集するには、EY ネットワークに接続している必要がある場合があります。再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
  apiServerError:
    "EY Canvasへの接続中にエラーが発生しました。再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
  duplicateDocumentNameError: "文書名が重複しています",
  APIValidationError:
    "EY Canvasで一部のレコードを更新できませんでした。詳細については、<b> ステータス</b>列を確認してください。",
  excelPopulatingMessage:
    "Excelにデータを設定しています。これには数分かかる場合があります。データの読込みが完了するまで、Excelワークシートをクリックしないでください。",
  generalError:
    "エラーが発生しました。EY Canvas Bulk Updateアドインを更新して、再試行してください。",
  boundSheetAlreadyPopulated:
    "このワークブックでは、別のEY Canvas Bulk Updateアドインが既に開始されています。新規ワークブックで再試行してください。",
  excelRenderIssue:
    "Excelワークシートがクリックされたため、EY Canvasからのデータの読込みが中断されました。再試行するには、新しいワークブックでEY Canvas Excel Add-inセッションを開始してください。",
  offlineModeLoadingMessage:
    "EY CanvasのExcelアドインを開いています。これには数分かかる場合があります。データの読込みが完了するまで、Excelワークシートをクリックしないでください。",
  offlineModeUserClickError:
    "EY Canvas Bulk Update Add-inを開いている最中に、Excelのワークシートをクリックしたため、プロセスが中断されました。EY Canvas Bulk Update Add-inを閉じてから再試行してください。",
  inActiveWorkbookError:
    "EY Canvas Bulk Update Add-inでエラーが発生しました。新しいワークブックを開いてから再試行してください。このエラーを防ぐために、データが入力されている間はワークブックの切り替えをしないでください。",
  clientRequestTitleMissing: "タイトルがありません（必須）",
  addclinetRequestTagError:
    "EY Canvas内にリクエストは作成されましたが、タグを追加することはできませんでした。手作業にてEY Canvasにタグを追加してください。",
  editclinetRequestTagError:
    "リクエストされたタグを編集することができませんでした。手作業にてEY Canvasにタグを追加してください。",
  clinetRequestEYContactError:
    "リクエストされたEYの連絡先を編集することができませんでした。手作業にてEY Canvasに連絡先を追加してください。",
  forbiddenByEYError:
    "このアクションはEY Information Securityによって禁止されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
  genericErrorMessage:
    "EY Canvas Bulk Update Add-inでエラーが発生しました。新しいワークブックを開いてから再試行してください。",
  itgcName: "ITGC名称（必須）",
  misstatementIndex: "JA JP Misstatement index (required)",
  misstatementDescription: "JA JP Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "統制名（必須）",
  frequency: "頻度",
  designEffectiveness: "デザインの有効性",
  controlType: "統制タイプ",
  controlId: "統制ID",
  operatingEffectiveness: "運用状況の有効性",
  testing: "テスト",
  itControlId: "IT統制ID",
  isControlLowerRisk: "統制は低リスクか？",
  timePhaseName: "JA JP Time phase name (required)",
  milestoneRequired: "マイルストーン (required)",
  startDate: "JA JP Start date (YYYY-MM-DD) (required)",
  endDate: "JA JP End date (YYYY-MM-DD) (required)",
  keyEvent: "JA JP Key event",
  timePhaseId: "タイムフェーズID",
  startDateFormatError: "JA JP Invalid date format in Start date",
  endDateFormatError: "JA JP Invalid date format in End date",
  deficiencyTitle: "JA JP Deficiency name (required)",
  deficiencyDescription: "JA JP Deficiency description (required)",
  deficiencyCategory: "JA JP Deficiency relates to",
  deficiencyId: "JA JP Deficiency ID",
  prefix: "プレフィックス",
  suffix: "サフィックス",
  requiredTitle: "タイトル（必須）",
  timePhaseRequired: "タイムフェーズ（必須）",
  taskGroupRequired: "タスクグループ（必須）",
  taskGroups: "タスクグループ",
  customizedDescription: "カスタマイズされた説明",
  customizedDescriptionRequired: "カスタマイズされた説明（必須）",
  picSignOffRequired: "PICサインオフ",
  eqrSignOffRequired: "EQR（IRP）サインオフ",
  invalidDataInTags: "タグ内の無効なデータ",
  taskTags: "タグ",
  editTaskAPIError:
    "タグをこのタスクで編集することができませんでした。手作業にてEY Canvasにタグを追加又は削除してください。",
  engagementLDCVersionUpdateError:
    "EY Canvas Bulk Updateアドインの更新が利用可能です。新しいワークブックでアドインを開いて、タスク名の変更を保存してください。",
  module: "モジュール",
  titleForMultiSelectInputMessage: "複数選択ドロップダウン",
  descriptionForMultiSelectInputMessage:
    "右側のアドインペインを使用して、1つ以上のドロップダウンオプションを選択してください。",
  errorBoundaryMessage:
    "JA JP An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "フィールド名",
  additionalInstructions: "追加インストラクション",
  toUploadAsDraft: "ドラフトとしてアップロード",
  toSaveAsDraft: "ドラフトとして保存",
  toSendToClient: "クライアントに送信",
  bulkUpdateAddIn: "EY Canvas Bulk Updateアドイン",
  purpose: "目的",
  guidance: "ガイダンス",
  overView: "フィールドの概要",
  required: "必須",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "このツールの使用により、EY Canvasコラボレーションでクライアントのリクエストを一括編集することができます。",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "EY Canvasコラボレーションの使用方法、特にEY Canvasコラボレーションからの一括編集やリクエストの送信方法についての追加ガイダンスについては、EY Atlasリンクを参照してください。",
  additionalInfo:
    "\u00B9 これは複数選択ドロップダウンフィールドです。このフィールドを編集するには、右側のアドインペインのドロップダウンを使用してください。",
  bulkUpdate: "\u00B2 追加インストラクションの確認",
};
export const instructionSheetDataForAddTaskOST = {
  purpose:
    "このツールは、新しいタスク（OSTs）をEY Canvasに一括アップロードする際に使用できます。",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "EY Canvasのタスクの一括割当ての方法を含め、EY Canvasのタスクの割当てに関する追加ガイダンスについては、EY Atlasのリンクを参照してください。",
  additionalInfo:
    "\u00B9 これは複数選択ドロップダウンフィールドです。このフィールドを編集するには、右側のアドインペインのドロップダウンを使用してください。",
};
export const instructionSheetDataForEditTasks = {
  purpose:
    "このツールの使用により、EY Canvasでタスクを一括編集することができます。",
  guidanceHyperlinkforStandardizedIndexing: "標準化されたインデックス",
  guidanceforStandardizedIndexing:
    "このツールは、タスクの標準化されたインデックス作成を容易にするために使用できます。標準化されたインデックス作成の詳細については、EY Atlasガイダンスリンクを参照してください。",
  guidanceHyperlinkForTaskAssignments: "タスクの割当て",
  guidanceForTaskAssignments:
    "EY Canvasのタスクの一括割当ての方法を含め、EY Canvasのタスクの割当てに関する追加ガイダンスについては、EY Atlasのリンクを参照してください。",
  additionalInfo:
    "\u00B9 これは複数選択ドロップダウンフィールドです。このフィールドを編集するには、右側のアドインペインのドロップダウンを使用してください。",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、レコードをEY Canvasに送信されるリストから除外することになります",
    required: "はい",
  },
  {
    count: "2",
    fieldName: "プレフィックス",
    additionalInstructions:
      "標準化されたインデックスの命名規則をサポートするためにプレフィックスを使用してください（50文字以内）",
    required: "いいえ",
  },
  {
    count: "3",
    fieldName: "タイトル",
    additionalInstructions:
      "タスクを効率的に管理するための命名規則を作成してください。（500文字以内）",
    required: "はい",
  },
  {
    count: "4",
    fieldName: "サフィックス",
    additionalInstructions: "50文字以内",
    required: "いいえ",
  },
  {
    count: "5",
    fieldName: "タイムフェーズ",
    additionalInstructions:
      "有効なプロジェクト管理をサポートするために、タスクをタイムフェーズに割当てます",
    required: "はい",
  },
  {
    count: "6",
    fieldName: "タスクグループ",
    additionalInstructions:
      "監査作業を管理可能なタスクのグループに整理します。タスクグループはOSTsについてのみ編集できます。",
    required: "はい",
  },
  {
    count: "7",
    fieldName: "カスタマイズされた説明",
    additionalInstructions: "このタスクで実施する手続を説明してください",
    required: "いいえ",
  },
  {
    count: "8",
    fieldName: "タグ \u00B9",
    additionalInstructions:
      "EY Canvasでタスク管理を支援するために、タグのラベルはカスタマイズすることが可能です",
    required: "いいえ",
  },
  {
    count: "9",
    fieldName: "PICサインオフ",
    additionalInstructions:
      "タスクにPICのサインオフが必要か否かを示してください（ナレッジでPICのサインオフが指定されている場合編集できません）",
    required: "いいえ",
  },
  {
    count: "10",
    fieldName: "EQRサインオフ",
    additionalInstructions:
      "タスクにEQRのサインオフが必要か否かを示してください（ナレッジでEQRのサインオフが指定されている場合編集できません）",
    required: "いいえ",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、リクエストをEY Canvasに送信されるリストから除外することになります。",
    toSaveAsDraft: "はい",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "タイトル",
    additionalInstructions:
      "全てのリクエストを効率的に管理するための命名規則を作成してください。",
    toSaveAsDraft: "はい",
    toSendToClient: "はい",
  },
  {
    count: "3",
    fieldName: "説明",
    additionalInstructions: "説明は4,000文字を超えることはできません",
    toSaveAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
  {
    count: "4",
    fieldName: "割当先（グループ）",
    additionalInstructions:
      "リクエストを外部ユーザーまたはグループに割当てます。\r\n - グループに割当てる場合は、「割当先（グループ）」から選択し、次の列を空にしてください。\r\n - 特定のユーザーに割当てる場合は、ユーザーを選択し、前の列を空にしてください。ユーザーはグループ別にリストされています。\r\n \r\n注:全てのグループメンバーがリクエストを閲覧できるようになります。ユーザーが複数のグループに属している場合は、正しいドロップダウンオプションを選択しているか確認してください。",
    toSaveAsDraft: "いいえ",
    toSendToClient: "これらのうち1つは必須です",
  },
  {
    count: "5",
    fieldName: "割当先 (ユーザー)",
    additionalInstructions: "",
    toSaveAsDraft: "いいえ",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "期日 (YYYY-MM-DD)",
    additionalInstructions:
      "期日はYYYY-MM-DD形式で指定する必要があります。期日を指定せずに時間フェーズを選択した場合、期日は時間フェーズの終了日にデフォルト設定されます。",
    toSaveAsDraft: "いいえ",
    toSendToClient: "はい \u00B2",
  },
  {
    count: "7",
    fieldName: "EYの連絡先 \u00B9",
    additionalInstructions:
      "外部ユーザーが質問がある場合に、連絡先となるEY担当者を追加します。EY担当者は、クライアントがリクエストに回答したときに通知を受け取ります。",
    toSaveAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
  {
    count: "8",
    fieldName: "タグ \u00B9",
    additionalInstructions:
      "タグは、コラボレーションで利用可能なカスタムラベルで、リクエストの管理に役立ちます。チームによって適用されたタグと、外部ユーザーによって適用されたタグが表示されます。コラボレーションとEY Canvas Client Portal間で自動的にタグが同期されます。",
    toSaveAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
  {
    count: "9",
    fieldName: "優先度",
    additionalInstructions:
      "クライアントがリクエストを優先順位付けするのに役立つように、リクエストの優先度を「高」又は「クリティカル」に設定してください。指定がない場合、リクエストは既定の優先度の「中」に設定されます。",
    toSaveAsDraft: "いいえ",
    toSendToClient: "はい \u00B2",
  },
  {
    count: "10",
    fieldName: "タイムフェーズ",
    additionalInstructions:
      "タイムフェーズ及び/または期日を選択します(上記参照)。",
    toSaveAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
];

export const instructionSheetData = {
  purpose:
    "このツールは、新しいクライアントのリクエストをEY Canvasコラボレーションに一括アップロードする際に使用できます。リクエストは「ドラフト」ステータスでアップロードされます。その後、EY Canvasコラボレーションからクライアントにリクエストを一括送信することができます。",
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "EY Canvasコラボレーションの使用方法、特にEY Canvasコラボレーションからの一括編集やリクエストの送信方法についての追加ガイダンスについては、EY Atlasリンクを参照してください。",
  additionalInfo: "追加インストラクションを確認",
  bulkUpdate:
    "\u00B9 これは複数選択ドロップダウンフィールドです。このフィールドを編集するには、右側のアドインペインのドロップダウンを使用してください。",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、リクエストをEY Canvasに送信されるリストから除外することになります。",
    toUploadAsDraft: "はい",
    toSendToClient: "N/A",
  },
  {
    count: "2",
    fieldName: "タイトル（必須）",
    additionalInstructions:
      "全てのリクエストを効率的に管理するための命名規則を作成してください。",
    toUploadAsDraft: "はい",
    toSendToClient: "はい",
  },
  {
    count: "3",
    fieldName: "説明",
    additionalInstructions: "説明は4,000文字を超えることはできません",
    toUploadAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
  {
    count: "4",
    fieldName: "割当先（グループ）",
    additionalInstructions:
      "リクエストを外部ユーザーまたはグループに割当てます。\r\n - グループに割当てる場合は、「割当先（グループ）」から選択し、次の列を空にしてください。\r\n - 特定のユーザーに割当てる場合は、ユーザーを選択し、前の列を空にしてください。ユーザーはグループ別にリストされています。\r\n \r\n注:全てのグループメンバーがリクエストを閲覧できるようになります。ユーザーが複数のグループに属している場合は、正しいドロップダウンオプションを選択しているか確認してください。",
    toUploadAsDraft: "いいえ",
    toSendToClient: "これらのうち1つは必須です",
  },
  {
    count: "5",
    fieldName: "割当先 (ユーザー)",
    additionalInstructions: "",
    toUploadAsDraft: "いいえ",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "期日 (YYYY-MM-DD)",
    additionalInstructions:
      "期日はYYYY-MM-DD形式で指定する必要があります。期日を指定せずに時間フェーズを選択した場合、期日は時間フェーズの終了日にデフォルト設定されます。",
    toUploadAsDraft: "いいえ",
    toSendToClient: "はい \u00B2",
  },
  {
    count: "7",
    fieldName: "EYの連絡先 \u00B9",
    additionalInstructions:
      "外部ユーザーが質問がある場合に、連絡先となるEY担当者を追加します。EY担当者は、クライアントがリクエストに回答したときに通知を受け取ります。",
    toUploadAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
  {
    count: "8",
    fieldName: "タグ \u00B9",
    additionalInstructions:
      "タグは、コラボレーションで利用可能なカスタムラベルで、リクエストの管理に役立ちます。チームによって適用されたタグと、外部ユーザーによって適用されたタグが表示されます。コラボレーションとEY Canvas Client Portal間で自動的にタグが同期されます。",
    toUploadAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
  {
    count: "9",
    fieldName: "優先度",
    additionalInstructions:
      "クライアントがリクエストを優先順位付けするのに役立つように、リクエストの優先度を「高」又は「クリティカル」に設定してください。指定がない場合、リクエストは既定の優先度の「中」に設定されます。",
    toUploadAsDraft: "いいえ",
    toSendToClient: "はい \u00B2",
  },
  {
    count: "10",
    fieldName: "タイムフェーズ",
    additionalInstructions:
      "タイムフェーズ及び/または期日を選択します(上記参照)。",
    toUploadAsDraft: "いいえ",
    toSendToClient: "いいえ",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose:
    "このツールの使用により、EY CanvasでITGCの詳細を一括編集することができます。",
  additionalInfo:
    "\u002AEY Canvasにすでに指定されている値は、変更することはできますが、削除することはできません。",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "JA JP This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002AEY Canvasにすでに指定されている値は、変更することはできますが、削除することはできません。",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "JA JP Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると:\r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、レコードをEY Canvasに送信されるリストから除外することになります",
    required: "はい",
  },
  {
    count: "2",
    fieldName: "JA JP Misstatement index",
    additionalInstructions:
      "JA JP Unique identifier for the misstatement (100 character limit)",
    required: "はい",
  },
  {
    count: "3",
    fieldName: "JA JP Misstatement description",
    additionalInstructions:
      "JA JP Description of the misstatement (500 character limit)\n",
    required: "はい",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose:
    "このツールは、新しいタスク（OSTs）をEY Canvasに一括アップロードする際に使用できます。",
  additionalInfo:
    "\u002AEY Canvasにすでに指定されている値は、変更することはできますが、削除することはできません。",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、レコードをEY Canvasに送信されるリストから除外することになります",
    required: "はい",
  },
  {
    count: "2",
    fieldName: "プレフィックス",
    additionalInstructions:
      "標準化されたインデックスの命名規則をサポートするためにプレフィックスを使用してください（50文字以内）",
    required: "いいえ",
  },
  {
    count: "3",
    fieldName: "タイトル",
    additionalInstructions:
      "タスクを効率的に管理するための命名規則を作成してください。（500文字以内）",
    required: "はい",
  },
  {
    count: "4",
    fieldName: "サフィックス",
    additionalInstructions: "50文字以内",
    required: "いいえ",
  },
  {
    count: "5",
    fieldName: "タイムフェーズ",
    additionalInstructions:
      "有効なプロジェクト管理をサポートするために、タスクをタイムフェーズに割当てます",
    required: "はい",
  },
  {
    count: "6",
    fieldName: "タスクグループ",
    additionalInstructions:
      "作業を管理可能なタスクのグループに整理してください",
    required: "はい",
  },
  {
    count: "7",
    fieldName: "カスタマイズされた説明",
    additionalInstructions: "このタスクで実施する手続を説明してください",
    required: "はい",
  },
  {
    count: "8",
    fieldName: "タグ \u00B9",
    additionalInstructions:
      "EY Canvasでタスク管理を支援するために、タグのラベルはカスタマイズすることが可能です",
    required: "いいえ",
  },
  {
    count: "9",
    fieldName: "PICサインオフ",
    additionalInstructions:
      "タスクにPICのサインオフが必要か否かを示してください",
    required: "いいえ",
  },
  {
    count: "10",
    fieldName: "EQRサインオフ",
    additionalInstructions:
      "タスクにEQRのサインオフが必要か否かを示してください",
    required: "いいえ",
  },
];
export const instructionSheetStaticDataControl = {
  purpose:
    "このツールの使用により、EY Canvasで統制の詳細を一括編集することができます。",
  additionalInfo:
    "\u002AEY Canvasのこのフィールドですでに指定されている値は、変更することはできますが、削除することはできません。",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "JA JP This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "JA JP Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、レコードをEY Canvasに送信されるリストから除外することになります",
    required: "はい",
  },
  {
    count: "2",
    fieldName: "タイムフェーズ名",
    additionalInstructions: "JA JP 500 character limit",
    required: "はい",
  },
  {
    count: "3",
    fieldName: "マイルストーン",
    additionalInstructions: "JA JP Select a milestone from the drop-down list",
    required: "はい",
  },
  {
    count: "4",
    fieldName: "開始日",
    additionalInstructions: "JA JP Must be specified in YYYY-MM-DD format",
    required: "はい",
  },
  {
    count: "5",
    fieldName: "終了日",
    additionalInstructions: "JA JP Must be specified in YYYY-MM-DD format",
    required: "はい",
  },
  {
    count: "6",
    fieldName: "JA JP Key event",
    additionalInstructions:
      "JA JP Indicate if this milestone is a key event in the completion of audit work",
    required: "いいえ",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、レコードをEY Canvasに送信されるリストから除外することになります",
    required: "はい",
  },
  {
    count: "2",
    fieldName: "ITGC名称（必須）",
    additionalInstructions: "ITGC名称は500文字を超えることはできません",
    required: "はい",
  },
  {
    count: "3",
    fieldName: "頻度",
    additionalInstructions: "ドロップダウンリストから統制の頻度を選択",
    required: "いいえ\u002A",
  },
  {
    count: "4",
    fieldName: "デザインの有効性",
    additionalInstructions:
      "デザインの有効性評価が完了したら、結論（有効又は非有効）を記載してください。",
    required: "いいえ",
  },
  {
    count: "5",
    fieldName: "運用状況の有効性",
    additionalInstructions:
      "デザインの有効性評価が完了したら、結論（有効又は非有効）を記載してください。",
    required: "いいえ",
  },
  {
    count: "6",
    fieldName: "テスト",
    additionalInstructions: "この統制をテストするか否かを記載してください",
    required: "いいえ",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "EY Canvasにアップロード",
    additionalInstructions:
      "アドイン上の「EY Canvasの更新」ボタンをクリックすると: \r\n -「はい」は、リクエストをEY Canvasに送信されるリストに含めることになります。\r\n -「いいえ」は、レコードをEY Canvasに送信されるリストから除外することになります",
    required: "はい",
  },
  {
    count: "2",
    fieldName: "統制名（必須）",
    additionalInstructions: "統制名は500文字を超えることはできません",
    required: "はい",
  },
  {
    count: "3",
    fieldName: "頻度",
    additionalInstructions: "ドロップダウンリストから統制の頻度を選択",
    required: "いいえ\u002A",
  },
  {
    count: "4",
    fieldName: "統制タイプ",
    additionalInstructions: "ドロップダウンリストから統制タイプを選択",
    required: "いいえ\u002A",
  },
  {
    count: "5",
    fieldName: "デザインの有効性",
    additionalInstructions:
      "デザインの有効性評価が完了したら、結論（有効又は非有効）を記載してください。",
    required: "いいえ",
  },
  {
    count: "6",
    fieldName: "運用状況の有効性",
    additionalInstructions:
      "デザインの有効性評価が完了したら、結論（有効又は非有効）を記載してください。",
    required: "いいえ",
  },
  {
    count: "7",
    fieldName: "テスト",
    additionalInstructions: "この統制をテストするか否かを記載してください",
    required: "いいえ",
  },
  {
    count: "8",
    fieldName: "統制は低リスクか？",
    additionalInstructions: "この統制が低リスクか否かを記載してください",
    required: "いいえ",
  },
];

export const errors = {
  14057: "文書名が重複しています",
  14084: "文書名に次の文字を含めることはできません */:<>\\?|" + '"',
  14085: "文書名は115 文字を超えることはできません",
  14086: "文書の詳細の更新中にDocServiceが失敗しました。",
  14088: "文書名が重複しています",
  5166: "このタスクタイプでは、タスクのタイトルは編集できません",
  5170: "文字数の制限を超えています（タイトル：500文字；プレフィックス/サフィックス：50文字）",
  5169: "文字数の制限を超えています（タイトル：500文字；プレフィックス/サフィックス：50文字）",
  5047: "文字数の制限を超えています（タイトル：500文字；プレフィックス/サフィックス：50文字）",
  5018: "EY Canvasでタスクが削除または差戻されました",
  14071: "ファイル名は必須です",
  14054: "ファイル名は必須です",
  409: "重複する文書名",
  21071:
    "本文で送信されたクライアントリクエスト数が、最大許容制限を超えています。",
  21041: "タイトルが500文字の制限を超えています",
  21076: "優先度の無効なデータ",
  21042: "説明が4,000文字の制限を超えています",
  21072: "期日のデータが無効です",
  21027: "タイトルがありません (必須)",
  21039: "有効なグループ/ユーザーをリクエストに割当ててください",
  21032: "有効なグループ/ユーザーをリクエストに割当ててください",
  21034: "JA JP Client Group does not have active users",
  21035: "EY Canvasでリクエストが見つかりませんでした。",
  21036: "タイムフェーズのデータが無効です",
  21057:
    "EYの連絡先はエンゲージメントメンバーではないか、アクティブではないか、または「独立性のみ」です",
  21073:
    "リクエストペイロードの1つまたは複数のデータが無効です。データを確認し再試行してください。",
  21074: "受領したリクエストのタイトル、説明、優先度は変更できません",
  21075:
    "承諾されたリクエストのタイトル、説明、割当て（グループ）、割当て（ユーザー）、期限、優先度、タイムフェーズは変更できません",
  21076: "PriorityTypeId列挙型には 1、2、又は 3 を含めることはできません",
  21077: "期限をYYYY-MM-DD形式で指定",
  21078:
    "割当てられたグループ又は割当てられたユーザーを更新する場合は、グループとユーザーのそれぞれが必須です。",
  21079: "期限をYYYY-MM-DD形式で指定",
  21080: "タイムフェーズが利用可能な場合、期限は必須です。",
  21081: "EYの連絡先が無効であるか、重複しています",
  25000: "タイムフェーズを指定",
  26000: "期限をYYYY-MM-DD形式で指定",
  84006: "ITGC名は必須です",
  84007: "ITGC名が500文字を超えています",
  84008: "無効な頻度データ",
  84029: "無効な頻度データ",
  84010: "無効なデザインの有効性データ",
  84027: "無効なテスト内のデータ",
  84028: "無効なテストデータ",
  84031:
    "テストで「いいえ」の場合、運用状況の有効性について結論を出すことはできません",
  84032: "無効なデザインの有効性データ",
  84004: "無効なIT統制ID",
  37007: "JA JP Misstatement index is required",
  37009: "JA JP Misstatement description is required",
  37130: "JA JP Misstatement description exceeds 500 character limit",
  37036: "JA JP Invalid Misstatement ID",
  37072: "JA JP Misstatement index exceeds 100 character limit",
  83018: "統制名が500文字を超えています",
  83004: "無効な統制ID",
  83006: "統制名は必須です",
  83009: "無効な頻度データ",
  83010: "無効な統制タイプデータ",
  83031: "無効な手作業統制テストIPEデータ",
  83012: "無効なデザインの有効性データ",
  83033: "無効な運用状況の有効性データ",
  83034: "無効なテストデータ",
  36023: "JA JP Invalid Deficiency ID",
  36044: "JA JP Deficiency name is required",
  36045: "JA JP Deficiency name exceeds 100 character limit",
  36005: "JA JP Deficiency description is required",
  36006: "JA JP Deficiency description exceeds 4000 character limit",
  5169: "プレフィックスが50文字の制限を超えています",
  5170: "サフィックスが50文字の制限を超えています",
  5047: "タイトルが500文字の制限を超えています",
  5108: "説明が最大文字数 (4000文字)を超えています",
  5059: "タイムフェーズ（必須）のデータが無効です",
  5111: "タスクグループ（必須）のデータが無効です",
  5051: "タスクグループ（必須）のデータが無効です",
  5019: "カスタマイズされた説明（必須）が必要です。",
  5103: "タイトル（必須）が必要です。",
  5104: "タイムフェーズ（必須）が必要です。",
  5109: "タスクグループ（必須）が必要です。",
  5203: "PICサインオフが必須です",
  5204: "EQRサインオフが必須です",
  5202: "タスクグループは変更できません",
  5168: "タイトル(必須)が必要です",
  16003: "JA JP Invalid Time phase ID",
  16006: "JA JP Invalid data in Time phase name (required)",
  16007: "JA JP Invalid data in Milestone",
  16008: "JA JP Invalid data in Start date",
  16009: "JA JP Invalid data in End date",
  16010: "JA JP Time phase name (required) is required",
  16022: "JA JP Specify a date later than 1900-01-01",
  16023: "JA JP End date must be on or after the Start date",
  16024: "JA JP Key event is required",
  16025: "JA JP Start date must be on or before the End date",
  16026: "JA JP Time phase deleted or not found in EY Canvas",
  16027: "JA JP Time phase name exceeds 500 character limit",
  16028: "JA JP Milestone (required) is required",
  16029: "JA JP Start date (YYYY-MM-DD) (required) is required",
  16030: "JA JP End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "スコープ",
  2: "戦略",
  3: "ウォークスルー",
  4: "期中統制テスト",
  5: "期中実証テスト",
  6: "ウォークスルー（期末プロセス）",
  7: "期末統制テスト",
  8: "期末実証テスト",
  9: "結論",
  10: "N/A",
  11: "実施",
  12: "JA JP Group audit S&S",
  13: "JA JP Preliminary planning",
  14: "CRA",
  15: "JA JP Identify and assess risk",
  16: "JA JP Design response to risk",
  17: "ポストインテリムプロジェクトマネジメント",
};

export const clientRequestStatusType = {
  1: "ドラフト",
  2: "ドラフト",
  5: "ドラフト",
  10: "ドラフト",
  11: "ドラフト",
  14: "ドラフト",
  17: "ドラフト",
  6: "回答待ち",
  9: "回答待ち",
  13: "回答待ち",
  16: "回答待ち",
  20: "回答待ち",
  21: "回答待ち",
  27: "回答待ち",
  7: "受領済",
  12: "受領済",
  15: "受領済",
  18: "受領済",
  19: "受領済",
  8: "承諾済",
  28: "承諾済",
};

export const filterAuditPhases = {
  1: "スコープ及び戦略",
  2: "実施",
  3: "総括",
};

export const taskTypeAbbreviation = {
  1: "TOC",
  2: "TOC",
  3: "TOC",
  4: "TOC",
  5: "TOC",
  6: "TOC",
  7: "RT",
  8: "RT",
  9: "RT",
  10: "RT",
  11: "RT",
  12: "OST",
  13: "OST",
  14: "PST",
  15: "OSP",
  16: "OSP",
  17: "PSP",
  18: "UDP",
  19: "UDP",
  20: "UDP",
  21: "UDP",
  22: "ACT",
  23: "GT",
  24: "GT",
  25: "GT",
  26: "OSP",
  27: "GT",
  28: "UDP",
  29: "JA JP EDC",
  30: "UDP",
  31: "UDP",
  32: "JA JP EDC",
  34: "RT",
};

export const uploadStatusLabels = {
  1: "同期保留中", //pending
  2: "オフライン編集済", //offlineEdit
  3: "ダウンロード済", //downloaded
  4: "アップロード済", //uploaded
  5: "無効な入力", //invalidInput
  6: "サーバーエラー", //serverError
  7: "予期しないAPIエラー", //unexpectedAPIError
  8: "クライアントフェッチエラー", //clientFetchError
  9: "後処理エラー", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "EY Canvasの更新",
  priority: "優先度",
  assignedToGroups: "割当先 (グループ)",
  assignedToUsers: "割当先 (ユーザー)",
  eyContacts: "EY担当者",
  tags: "タグ",
  timephases: "タイムフェーズ",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "EY Canvasの更新",
  timePhase: "タイムフェーズ",
  taskGroup: "タスクグループ",
  tags: "タグ",
  timephasename: "タイムフェーズ名",
  startDate: "開始日",
  endDate: "終了日",
  timePhaseId: "タイムフェーズID",
  taskGroupName: "タスクグループ名",
  auditPhase: "監査フェーズ",
  groupName: "グループ名",
  taskGroupId: "タスクグループID",
  tagDescription: "説明",
  tagGroup: "タググループ",
  tagLabel: "タグ",
  tagColor: "色",
  tagId: "タグID",
  signOff: "サインオフ",
  signOffValue: "サインオフの値",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "タイトル（必須）",
  clientRequestDescription: "説明",
  AssignedToGroup: "割当て先（グループ）",
  AssignedToUser: "割当て先（ユーザー）",
  DueDate: "期日（YYYY-MM-DD）",
  eyContact: "EY担当者",
  tags: "タグ",
  priority: "優先度",
  requestGuid: "クライアントリクエストGUID",
  requestId: "クライアントリクエストID",
  statusID: "ステータスID",
  timephases: "タイムフェーズ",
  requestHash: "リクエスト #",
  requestHashSpace: "リクエスト #",
  clientRequestTitleSpace: "タイトル（必須）",
  clientRequestDescriptionSpace: "説明",
  AssignedToGroupSpace: "割当先 (グループ)",
  AssignedToUserSpace: "割当先 (ユーザー)",
  DueDateSpace: "期日 (YYYY-MM-DD)",
  eyContactSpace: "EY担当者",
  tagsSpace: "タグ",
  prioritySpace: "優先度",
  timephasesSpace: "タイムフェーズ",
  requestStatusId: "リクエストステータスID",
  requestStatus: "リクエストステータス",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "優先度の名前",
    priorityTypeId: "優先度のタイプID",
  },
  assignedToGroups: {
    group: "グループ",
    groupName: "グループ名",
    groupId: "グループID",
  },
  assignedToUsers: {
    groupMember: "グループメンバー",
    name: "名前",
    groupName: "グループ名",
    userId: "ユーザーID",
    groupId: "グループID",
  },
  eyContacts: {
    name: "名前",
    userId: "ユーザーID",
  },
  tags: {
    tagName: "タグ",
    colorCode: "色",
    engagementTagName: "説明",
    engagementTagID: "タグID",
  },
  timephases: {
    timePhaseName: "タイムフェーズ",
    periodName: "タイムフェーズ名",
    startDate: "開始日",
    dueDate: "終了日",
    timephaseId: "タイムフェーズID",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "標準",
  },
  {
    value: 3,
    label: "高",
  },
  {
    value: 4,
    label: "クリティカル",
  },
];

export const ButtonOptions = [
  {
    label: "文書名の編集",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "クライアントリクエストのドラフト作成",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "クライアントリクエストの編集",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "ITGCの編集",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "タスクの編集",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "統制の編集",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "タスクの作成（OSTs）",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "JA JP Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 3.5,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "ドラフト",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "回答待ち",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "受領済",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "承諾済",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "赤",
    label: "赤",
  },
  {
    value: "橙",
    label: "橙",
  },
  {
    value: "青緑",
    label: "青緑",
  },
  {
    value: "青",
    label: "青",
  },
  {
    value: "紫",
    label: "紫",
  },
  {
    value: "緑",
    label: "緑",
  },
  {
    value: "黄色",
    label: "黄色",
  },
  {
    value: "灰",
    label: "灰",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "毎日何度も",
  },
  {
    id: 2,
    value: 2,
    label: "日次",
  },
  {
    id: 3,
    value: 3,
    label: "週次",
  },
  {
    id: 4,
    value: 4,
    label: "月次",
  },
  {
    id: 5,
    value: 5,
    label: "四半期毎",
  },
  {
    id: 6,
    value: 6,
    label: "年次",
  },
  {
    id: 8,
    value: 8,
    label: "その他",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "有効",
  },
  {
    id: 2,
    value: 2,
    label: "非有効",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "有効",
  },
  {
    id: false,
    value: false,
    label: "非有効",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "false",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "はい",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "いいえ",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "ITアプリケーション統制",
  },
  {
    id: 2,
    value: 2,
    label: "IT依存手作業統制",
  },
  {
    id: 3,
    value: 3,
    label: "手作業防止",
  },
  {
    id: 4,
    value: 4,
    label: "手作業発見",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "CRA",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "ポストインテリムプロジェクトマネジメント",
  },
  {
    id: 3,
    value: 3,
    label: "ウォークスルー",
  },
  {
    id: 4,
    value: 4,
    label: "期中統制テスト",
  },
  {
    id: 5,
    value: 5,
    label: "期中実証テスト",
  },
  {
    id: 6,
    value: 6,
    label: "ウォークスルー（期末プロセス）",
  },
  {
    id: 7,
    value: 7,
    label: "期末統制テスト",
  },
  {
    id: 8,
    value: 8,
    label: "期末実証テスト",
  },
  {
    id: 11,
    value: 11,
    label: "実施",
  },
  {
    id: 9,
    value: 9,
    label: "結論",
  },
  {
    id: 10,
    value: 10,
    label: "N/A",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];

export const instructionSheetDataForDeficiencies = {
  purpose: "JA JP This tool can be used to bulk edit deficiency details in EY Canvas.",
  guidanceHyperlink: "JA JP EY Atlas",
  guidance: "JA JP Refer to the EY Atlas link for additional guidance on evaluating control deficiencies.",
};

export const instructionSheetTabularDataDeficiencies = [
  {
    count: "JA JP 1",
    fieldName: "JA JP Update EY Canvas",
    additionalInstructions:
      "JA JP When you click the 'Update EY Canvas' button on the add-in:\r\n- 'Yes' will include the record in the list sent to EY Canvas\r\n- 'No' will exclude the record from the list sent to EY Canvas",
    required: "JA JP Yes",
  },
  {
    count: "JA JP 2",
    fieldName: "JA JP Deficiency title",
    additionalInstructions: "JA JP Unique identifier for the deficiency (100 character limit)",
    required: "JA JP Yes",
  },
  {
    count: "JA JP 3",
    fieldName: "JA JP Deficiency description",
    additionalInstructions: "JA JP Description of the control deficiency (4000 character limit)",
    required: "JA JP Yes",
  },
];